<ng-container *transloco="let t; read 'common-dialogs.confirm'">

  <psc-dialog
    *ngIf="showConfirmDialog"
    (closeClicked)="showConfirmDialog = false">
    <div class="flex flex-col items-center">
      <h2 class="mb-8 text-color-blue1">
        {{confirmDialogModel.titleKey ? (confirmDialogModel.titleKey | transloco) : t('are-you-sure')}}
      </h2>
      <div class="flex gap-4">
        <psc-button
          [label]="t('yes')"
          type="primary-blue-1"
          (buttonClicked)="confirm()"></psc-button>
        <psc-button
          [label]="t('no')"
          type="secondary-magenta"
          (buttonClicked)="decline()"></psc-button>
      </div>
    </div>
  </psc-dialog>
</ng-container>
